import React from 'react'
import { Icon, Spin } from 'antd'
import styles from '-/components/basic/Loading/loading.module.scss'

const Loading = (): JSX.Element => {
  return (
    <div className={styles['loading-container']}>
      <Spin indicator={<Icon type="loading" />} size="large" />
    </div>
  )
}

export default Loading
